<template>
  <div class="real-estate">
    <div v-if="translationsLoaded">
      <masterdata-ui
        :columns="columns" :grid-title="SR_RealEstate.DmsReferenceType"
        :modal-title-add="SR_RealEstate.AddDmsReferenceType" :modal-title-edit="SR_RealEstate.EditDmsReferenceType"
        :load-items-action-url="loadItemsActionUrl" :update-item-action-url="updateItemActionUrl"
        :create-item-action-url="createItemActionUrl"
        :build-object-for-request="buildDmsReferenceTypeObject" :setup-modal-content="setupModalContent"
      />
    </div>
  </div>
</template>

<script lang="js">
import makeResourceMixin from 'src/vue/mixins/make-resource-mixin'
import newGuid from 'src/js/helpers/new-guid'
import masterdataUi from './masterdata-ui'

const resources = {
  SR_RealEstate: 'Areas.RealEstate.SR_RealEstate'
}

export default {
  components: {
    masterdataUi
  },
  mixins: [makeResourceMixin(resources)],

  data () {
    return {
      loadItemsActionUrl: '/RealEstate/MasterDataDmsReferenceType/GetDmsReferenceTypes',
      updateItemActionUrl: '/RealEstate/MasterDataDmsReferenceType/Update',
      createItemActionUrl: '/RealEstate/MasterDataDmsReferenceType/Create',
      translationsLoaded: false
    }
  },

  computed: {

    columns () {
      return [
        {
          localizedTitle: this.SR_RealEstate['DmsReferenceType'],
          typeName: 'String',
          propertyName: 'name'
        },
        {
          localizedTitle: 'UID',
          typeName: 'String',
          propertyName: 'uid',
          isIdColumn: true,
          invisible: true
        }
      ]
    }
  },

  methods: {

    setupModalContent (data = {uid: newGuid(), name: ''}) {
      return [
        {propertyName: 'uid', value: data.uid, label: '', required: false, editable: false},
        {propertyName: 'name', value: data.name, label: this.SR_RealEstate.DmsReferenceType, required: true, editable: true}
      ]
    },

    buildDmsReferenceTypeObject (data) {
      return {
        uid: data[0].value, // TODO: find better solution
        name: data[1].value
      }
    }
  },

  created () {
    this.$store.dispatch('i18n/preloadTranslations', [
      'Areas.RealEstate.SR_RealEstate'
    ])
      .then(() => {
        this.translationsLoaded = true
      })
  }
}
</script>

<style lang="scss">
</style>
